var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link",style:(_vm.style),attrs:{"tag":"div","to":{ name: _vm.target }},nativeOn:{"click":function($event){return _vm.$emit('goto', _vm.target)},"touch":function($event){return _vm.$emit('goto', _vm.target)}}})}
var staticRenderFns = []

export { render, staticRenderFns }